<script lang="ts">
  import DropdownListItem from './DropdownListItem.svelte';

  interface Props {
    list: CommonList[];
    maxheight?: boolean;
    onclick?: (item: CommonList) => void;
  }

  let { list, maxheight = false, onclick }: Props = $props();
</script>

<div class="plain-list" class:maxheight>
  {#each list as item}
    <DropdownListItem {item} onclick={() => onclick?.(item)} />
  {/each}
</div>

<style>
  .plain-list {
    width: 100%;
    max-height: 300px;
    overflow: auto;
  }
  .plain-list.maxheight {
    max-height: 100%;
  }
</style>
